$(document).on('click', '#c-menu-account__logout', function (e) {
    e.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        data: {
            action: 'logout',
        },
        success: function () {
            // When the response comes back
            window.location.href = '/';
        },
    });
});

/* Gravity Forms - Confirmations */
const queryString = window.location.search; // Output is for example ?udpatedAccount=true
const urlParams = new URLSearchParams(queryString);

// if urlParams object is not empty
if (Object.keys(urlParams).length) {
    /* Gravity Forms - Confirmation in Account */
    const updatedAccount = urlParams.get('updatedAccount'); // Output can be true or false
    const sectionAccount = document.querySelector('.s-account');
    const accountForm = sectionAccount.querySelector('form');
    const messageAccount = document.createElement('p');
    messageAccount.classList.add('s-account__account-updated');
    const dataMessageAccountUpdated = sectionAccount.getAttribute('data-updated-account');
    messageAccount.innerHTML = dataMessageAccountUpdated;

    if (updatedAccount) {
        accountForm.prepend(messageAccount);
    }

    /* Gravity Forms - Confirmation in Account - Update password */
    const updatedPassword = urlParams.get('updatedPassword'); // Output can be true or false
    const sectionUpdatePassword = document.querySelector('.s-account-update-password');
    const passwordUpdateForm = sectionUpdatePassword.querySelector('form');
    const messageUpdatedPassword = document.createElement('p');
    messageUpdatedPassword.classList.add('s-account-update-password__password-updated');
    const dataMessagePasswordUpdated = sectionUpdatePassword.getAttribute('data-updated-password');
    messageUpdatedPassword.innerHTML = dataMessagePasswordUpdated;

    if (updatedPassword) {
        passwordUpdateForm.prepend(messageUpdatedPassword);
    }
}



// WEBPACK FOOTER //
// ./scripts/routes/other/user-registration.js